<template>
  <div>
    <div class="wei" style="padding-top: 100px;"><div>您当前位置： 首页 > {{$route.fullPath=='/xiang/guan'?'公司介绍':$route.fullPath=='/xiang/lian'?'联系我们':'产品中心'}}</div></div>
    <div class="xiang">
           <!--左边-->
             <div class="left">
             <div><img src="../assets/fenlei.png" alt=""> 全部分类</div>
             <Leftce :list='list'></Leftce>                  
           </div>
           <!--右边-->
           <div class="right">
              <router-view v-if="load"/>
           </div>
    </div>
 </div>
</template>
<script>
import Leftce from '../components/Leftce'
export default {
    data(){
        return{
          list:'',
          chanx:'',
          load:true
        }
    },
    components:{
        Leftce,
    },
    methods:{
     reload(){
         this.load=false
         this.$nextTick(() => {
          this.load=true 
        })
     }
    },
    watch: {
	'$route' () {
        this.reload();
	}
    },
    created(){
        this.axios.get('gType/all').then((res)=>{this.list=res.data;});
        console.log(this.$route)
    },
    mounted(){
        document.documentElement.scrollTop=0;
  
    }
}
</script>
<style scoped>
 .wei{
    background: #e2e0e0;
    font-size: 14px;
 }
 .wei>div{
    width: 1200px;
    margin: 10px auto 20px;
    padding: 10px 0;
 }
 .xiang{
     width: 1200px;
     margin: 15px auto  30px;
     display: flex;
     justify-content: space-between;
 }
 .left>div:first-child{
     width:231px;
     height:46px;
     background:rgba(234,0,4,1);
     text-align: center;
     font-size:24px;
     font-family:Microsoft YaHei;
     font-weight:bold;
     color:rgba(255,255,255,1);
     line-height:47px;
 }
 .left{
     width: 231px;
 }
 .right{
     width: 960px;
 }
 .left img{
    width:28px;
    height:20px;
 }

</style>